import { z } from "zod";

export const createContactSchema = (
  t: (key: string, values?: Record<string, any>) => string,
) => {
  return z.object({
    name: z
      .string({ message: t("validations.name.required") })
      .min(1, { message: t("validations.name.required") }),
    email: z
      .string({ message: t("validations.email.required") })
      .min(1, { message: t("validations.email.required") })
      .email({
        message: t("validations.email.invalid"),
      }),
    phone: z
      .string({ message: t("validations.phone.required") })
      .min(1, { message: t("validations.phone.required") }),
    subject: z
      .string({ message: t("validations.subject.required") })
      .min(1, { message: t("validations.subject.required") }),
    message: z
      .string({ message: t("validations.message.required") })
      .min(1, { message: t("validations.message.required") }),
  });
};

export type CreateContactSchemaType = z.infer<
  ReturnType<typeof createContactSchema>
>;
